import { useState } from 'react';

import { Box, H2, ListRow, Separator, Switch, Text } from '@betterment/samba-react';

import { ControlSettingsProps } from './SettingsControls';

const SettingsControlSwitch: React.FC<{
  name: string;
  title: string;
  defaultChecked?: boolean;
  switchTextHandler: (isChecked: boolean) => string;
}> = ({ name, title, defaultChecked, switchTextHandler }) => {
  const [isChecked, setIsChecked] = useState<boolean>(defaultChecked || false);

  const handleClick = () => {
    setIsChecked(!isChecked);
  };

  const switchAriaLabel = `${title} ${isChecked ? 'Selected' : 'Not Selected'}`;

  return (
    <>
      <Switch
        formStrategy="vanilla"
        value={isChecked ? 'checked' : 'unchecked'}
        name={name}
        defaultChecked={defaultChecked}
        onCheckedChange={handleClick}
        aria-label={switchAriaLabel}
      />
      <Text variant="text25" color="text.weak">
        {switchTextHandler(isChecked)}
      </Text>
    </>
  );
};

const SettingsControlCard: React.FC<ControlSettingsProps> = ({
  title,
  icon,
  subtitle,
  defaultChecked,
  detailModal,
  switchTextHandler,
  name,
  hideSwitch,
}) => {
  return (
    <Box
      css={{
        display: 'grid',
        gap: 'space.200',
        padding: 'space.200',
        border: '1px solid',
        borderColor: 'border.weak',
        borderRadius: 'medium',
      }}
    >
      <ListRow css={{ padding: 'space.0' }}>
        <ListRow.LeadingAsset>{icon}</ListRow.LeadingAsset>
        <ListRow.LeadingContent>
          <Box css={{ display: 'grid' }}>
            <H2 variant="title100">{title}</H2>
            {subtitle && (
              <Text as="p" variant="text50" color="text.success">
                {subtitle}
              </Text>
            )}
          </Box>
        </ListRow.LeadingContent>
        <ListRow.TrailingContent>
          <Box css={{ display: 'grid', gap: 'space.100', justifyItems: 'center' }}>
            {!hideSwitch && (
              <SettingsControlSwitch
                name={name}
                title={title}
                defaultChecked={defaultChecked}
                switchTextHandler={switchTextHandler}
              />
            )}
          </Box>
        </ListRow.TrailingContent>
      </ListRow>
      <Separator />
      {detailModal}
    </Box>
  );
};

export default SettingsControlCard;
